"use strict";

// TODO: This is a copy of url, only here because I can't get rollup plugins
// to play nicely - need to clean this up

const parse  = require("./external/parse-uri");
const object = require("./object");

const ports = {
        http  : 80,
        https : 443
    };

module.exports.parse = parse;

module.exports.format = function formatUrl(config) { // eslint-disable-line complexity
    /* eslint complexity: [ 2, 24 ] */
    let protocol = "",
        userinfo  = "",
        authority = "",
        relative  = "",
        query     = "",
        anchor    = "";

    if (typeof config === "string") {
        config = parse(config);
    }

    protocol = config.protocol ? `${config.protocol}://` : "//";

    // Attempt to build up the URL from most-specific to least-specific properties

    // user@
    if (config.user) {
        userinfo += config.user;
    }

    // user@password
    if (config.password) {
        if (!("user" in config)) {
            throw new Error("url.format() :: Password with a user doesn't make any sense!");
        }

        userinfo += `:${config.password}`;
    }

    // user:pass@
    if (config.userInfo && !userinfo) {
        userinfo = config.userInfo;
    }

    if (userinfo) {
        userinfo += "@";
    }

    // host
    if (config.host) {
        authority += config.host;
    }

    // :port
    if (config.port) {
        if (config.protocol) {
            if (config.port !== ports[config.protocol]) {
                authority += `:${config.port}`;
            }
        } else if (config.port !== ports.http) {
            authority += `:${config.port}`;
        }
    }

    // user:pass@host:port
    if (!authority) {
        authority = config.authority;
    }

    // /dir/dir/
    if (config.directory) {
        relative += config.directory;
    }

    // file.file
    if (config.file) {
        // Ensure there's a leading "/"
        if (relative.charAt(relative.length - 1) !== "/") {
            relative += "/";
        }

        relative += config.file;
    }

    // /dir/dir/file.file
    if (config.path && !relative) {
        relative = config.path;
    }

    // query key is an object, turn it into query string
    if (config.queryKey) {
        query = [];

        object.each(config.queryKey, function(value, key) {
            query.push(`${key}=${encodeURIComponent(value)}`);
        });

        query = query.join("&");

        if (query.length) {
            query = `?${query}`;
        }
    }

    // ?query1=qv1&query2=qv2
    if (config.query && !query) {
        query = `?${config.query}`;
    }

    // /#fooga
    if (config.anchor) {
        anchor = `#${config.anchor}`;
    }

    // /dir/dir/file.file?query1=qv1&query2=qv2#anchor
    if (config.relative && !relative && !query && !anchor) {
        relative = config.relative;
    }

    return (authority ? protocol + userinfo + authority : "") + relative + query + anchor;
};
